import {useQuery} from '@tanstack/react-query';

import {
  CART_FLYOUT_DISPLAY_QUERY_KEY,
  CART_FLYOUT_DISPLAY_STALE_TIME_MS,
} from '@amblique/king-living/app/utils/cart-flyout-display';

/**
 * Seeded catalog stubs for the mini-cart flyout (ATC + slim getProducts).
 *
 * @returns {Object<string, Object>}
 */
export function useCartFlyoutDisplay() {
  const {data} = useQuery({
    queryKey: CART_FLYOUT_DISPLAY_QUERY_KEY,
    queryFn: () => ({}),
    enabled: false,
    initialData: {},
    staleTime: Infinity,
    gcTime: CART_FLYOUT_DISPLAY_STALE_TIME_MS,
  });

  return data ?? {};
}

export default useCartFlyoutDisplay;
